<header id="page-topbar" data-scroll-header (window:scroll)="windowScroll()">
    <div class="layout-width">
        @if (topBarShowClock && !clockBarDismissed) {
            <app-clock-bar cssHeightVarName="--ss-topbar-clock-height"
                           (dismissed)="dismissClockBar()"
                           (heightChanged)="onClockBarHeightChanged($event)">
            </app-clock-bar>
        }
        <div class="navbar-header" [class.navbar-header-collapsed]="topbarIconsCollapsed" [style.height]="topbarIconsCollapsed ? 'auto' : null">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo" [class.d-none]="topbarIconsCollapsed">
                    <a href="javascript:void(0);" class="logo logo-dark" title="SureSIM">
                        <span class="logo-sm">
                            <img
                              alt=""
                              [height]="isPlatformModeInview ? 50 : 50"
                              [src]="isPlatformModeInview ? 'assets/images/myinview-logo-text-right-green-all.png' : 'assets/images/SureSIM-Logo-Dark-400.png'"
                            >
                        </span>
                        <span class="logo-lg">
                            <img
                              alt=""
                              [height]="isPlatformModeInview ? 50 : 50"
                              [src]="isPlatformModeInview ? 'assets/images/myinview-logo-text-right-green-all.png' : 'assets/images/SureSIM-Logo-Dark-400.png'"
                            >
                        </span>
                    </a>

                    <a href="javascript:void(0);" class="logo logo-light" title="SureSIM">
                        <span class="logo-sm">
                            <img
                              alt=""
                              [height]="isPlatformModeInview ? 50 : 50"
                              [src]="isPlatformModeInview ? 'assets/images/myinview-logo-text-right-green-all.png' : 'assets/images/SureSIM-Logo-Light-400.png'"
                            >
                        </span>
                        <span class="logo-lg">
                            <img
                              alt=""
                              [height]="isPlatformModeInview ? 50 : 50"
                              [src]="isPlatformModeInview ? 'assets/images/myinview-logo-text-right-green-all.png' : 'assets/images/SureSIM-Logo-Light-400.png'"
                            >
                        </span>
                    </a>
                </div>

                @if (!topbarIconsCollapsed) {

                    @if(topBarShowHamburger || showTemplateMenuItems) {
                    <button
                      class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                      id="topnav-hamburger-icon"
                      [ngbTooltip]="showTooltips ? 'Toggle Menu' : null"
                      placement="right"
                      tooltipClass="custom-tooltip-success"
                      (click)="toggleMobileMenu($event)"
                    >
                        <span class="hamburger-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </button>
                    }

                    @if((isPlatformMode && (currentRouteUrl==='/dashboard-main' || currentRouteUrl==='/dashboard-usage')) || showBackToPlatformInview) {
                    <div class="ms-1 header-item d-none d-sm-flex">
                      <button
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        [ngbTooltip]="showTooltips ? 'Back to Platform' : null"
                        placement="bottom"
                        tooltipClass="custom-tooltip-success"
                        type="button"
                        (click)="backToPlatformClick()"
                      >
                        <i class='bi bi-arrow-left-circle fs-22'></i>
                      </button>
                    </div>
                    }
    
                    @if (topBarShowSureSimSearch) {
                    <div class="ms-1 header-item d-none d-sm-flex">
                      <app-topbar-search (modalActionRequested)="onAssistantActionRequested($event)"></app-topbar-search>
                    </div>
                    }

                    <div class="ms-1 header-item d-none d-sm-flex" *ngIf="showAddCompanySimUserTools && showAddCompanyIcon">
                      <button
                        #tooltipAddCompany="ngbTooltip"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        [ngbTooltip]="showTooltips ? 'Add Company' : null"
                        placement="bottom"
                        tooltipClass="custom-tooltip-success"
                        type="button"
                        (click)="addCompanyIconClick()"
                        (mouseenter)="addCompanyIconMouseEnter()"
                      >
                          <i class='bi bi-building-add fs-22'></i>
                      </button>
                    </div>
    
                    <div class="ms-1 header-item d-none d-sm-flex" *ngIf="showAddCompanySimUserTools && showAddUserPortalIcon">
                      <button
                        #tooltipAddUserPortal="ngbTooltip"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        [ngbTooltip]="showTooltips ? 'Add Portal User' : null"
                        placement="bottom"
                        tooltipClass="custom-tooltip-success"
                        type="button"
                        (click)="addUserPortalIconClick()"
                        (mouseenter)="addUserPortalIconMouseEnter()"
                      >
                          <i class='bi bi-person-fill-add fs-22'></i>
                      </button>
                    </div>
    
                    <div class="ms-1 header-item d-none d-sm-flex" *ngIf="showAddCompanySimUserTools && showAddUserSimIcon">
                      <button
                        #tooltipAddUserSim="ngbTooltip"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        [ngbTooltip]="showTooltips ? 'Add SIM Subscriber' : null"
                        placement="bottom"
                        tooltipClass="custom-tooltip-success"
                        type="button"
                        (click)="addUserSimIconClick()"
                        (mouseenter)="addUserSimIconMouseEnter()"
                      >
                          <i class='bi bi-person-add fs-22'></i>
                      </button>
                    </div>
    
                    <div class="ms-1 header-item d-none d-sm-flex" *ngIf="showAddCompanySimUserTools && showAddSimIcon">
                      <button
                        #tooltipAddSim="ngbTooltip"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        [ngbTooltip]="showTooltips ? 'Provision SIM' : null"
                        placement="bottom"
                        tooltipClass="custom-tooltip-success"
                        type="button"
                        (click)="addSimIconClick()"
                        (mouseenter)="addSimIconMouseEnter()"
                      >
                          <i class='bi bi-sim fs-22'></i>
                      </button>
                    </div>
    
                    <div class="ms-1 header-item d-none d-sm-flex" *ngIf="showAddCompanySimUserTools && showAddSupportTicketIcon">
                      <button
                        #tooltipAddSupportTicket="ngbTooltip"
                        class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                        [ngbTooltip]="showTooltips ? 'Raise Support Ticket' : null"
                        placement="bottom"
                        tooltipClass="custom-tooltip-success"
                        type="button"
                        (click)="addSupportTicketIconClick()"
                        (mouseenter)="addSupportTicketIconMouseEnter()"
                      >
                          <i [ngClass]="supportTicketIconUseMan ? 'bi bi-person-arms-up fs-22' : 'bi bi-ticket-perforated fs-22'"></i>
                      </button>
                    </div>

                    @if (showDemoModeToggle) {
                      <div class="ms-2 header-item d-none d-sm-flex">
                        <div class="btn-group topbar-mode-toggle pill-toggle" role="group" aria-label="Display Mode">
                          <input type="radio" class="btn-check"
                                 id="topbarModeStandard"
                                 name="topbarMode"
                                 value="standard"
                                 [checked]="demoMode==='standard'"
                                 (change)="setDemoMode('standard')">
                          <label class="btn btn-outline-success mb-0" for="topbarModeStandard">Standard</label>

                          <input type="radio" class="btn-check"
                                 id="topbarModeDemo"
                                 name="topbarMode"
                                 value="demo"
                                 [checked]="demoMode==='demo'"
                                 (change)="setDemoMode('demo')">
                          <label class="btn btn-outline-success mb-0" for="topbarModeDemo">Demo</label>
                        </div>
                      </div>
                    }

                    @if(topBarShowSearch || showTemplateMenuItems) {
                    <form class="app-search d-none d-md-block">
                        <div class="position-relative">
                            <input type="text" class="form-control" placeholder="Search..." autocomplete="off" id="search-options" value="" (keyup)="search()">
                            <span class="mdi mdi-magnify search-widget-icon"></span>
                            <span class="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none" id="search-close-options" (click)="closeBtn()"></span>
                        </div>
                        <div class="dropdown-menu dropdown-menu-lg" id="search-dropdown">
                            <ngx-simplebar style="max-height: 320px;">
                                <!-- item-->
                                <div class="dropdown-header">
                                    <h6 class="text-overflow text-muted mb-0 text-uppercase">Recent Searches</h6>
                                </div>
    
                                <div class="dropdown-item bg-transparent text-wrap">
                                    <a href="javascript:void(0);" class="btn btn-soft-secondary btn-sm rounded-pill me-1">how to
                                        setup <i class="mdi mdi-magnify ms-1"></i></a>
                                    <a href="javascript:void(0);" class="btn btn-soft-secondary btn-sm rounded-pill">buttons
                                        <i class="mdi mdi-magnify ms-1"></i></a>
                                </div>
                                <!-- item-->
                                <div class="dropdown-header mt-2">
                                    <h6 class="text-overflow text-muted mb-1 text-uppercase">Pages</h6>
                                </div>
    
                                <!-- item-->
                                <a href="javascript:void(0);" class="dropdown-item notify-item">
                                    <i class="ri-bubble-chart-line align-middle fs-18 text-muted me-2"></i>
                                    <span>Analytics Dashboard</span>
                                </a>
    
                                <!-- item-->
                                <a href="javascript:void(0);" class="dropdown-item notify-item">
                                    <i class="ri-lifebuoy-line align-middle fs-18 text-muted me-2"></i>
                                    <span>Help Center</span>
                                </a>
    
                                <!-- item-->
                                <a href="javascript:void(0);" class="dropdown-item notify-item">
                                    <i class="ri-user-settings-line align-middle fs-18 text-muted me-2"></i>
                                    <span>My account settings</span>
                                </a>
    
                                <!-- item-->
                                <div class="dropdown-header mt-2">
                                    <h6 class="text-overflow text-muted mb-2 text-uppercase">Members</h6>
                                </div>
    
                                <div class="notification-list">
                                    <!-- item -->
                                    <a href="javascript:void(0);" class="dropdown-item notify-item py-2">
                                        <div class="d-flex">
                                            <img src="assets/images/users/avatar-2.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                            <div class="flex-grow-1">
                                                <h6 class="m-0">Angela Bernier</h6>
                                                <span class="fs-11 mb-0 text-muted">Manager</span>
                                            </div>
                                        </div>
                                    </a>
                                    <!-- item -->
                                    <a href="javascript:void(0);" class="dropdown-item notify-item py-2">
                                        <div class="d-flex">
                                            <img src="assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                            <div class="flex-grow-1">
                                                <h6 class="m-0">David Grasso</h6>
                                                <span class="fs-11 mb-0 text-muted">Web Designer</span>
                                            </div>
                                        </div>
                                    </a>
                                    <!-- item -->
                                    <a href="javascript:void(0);" class="dropdown-item notify-item py-2">
                                        <div class="d-flex">
                                            <img src="assets/images/users/avatar-5.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                            <div class="flex-grow-1">
                                                <h6 class="m-0">Mike Bunch</h6>
                                                <span class="fs-11 mb-0 text-muted">React Developer</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </ngx-simplebar>
    
                            <div class="text-center pt-3 pb-1">
                                <a href="pages/search-results" class="btn btn-primary btn-sm">View All Results <i class="ri-arrow-right-line ms-1"></i></a>
                            </div>
                        </div>
                    </form>
                    }
                }
            </div>

            <div class="d-flex align-items-center">

                @if (!topbarIconsCollapsed) {
                    <div class="dropdown d-md-none topbar-head-dropdown header-item" ngbDropdown>
                        <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                            <i class="bx bx-search fs-22"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown" ngbDropdownMenu>
                            <form class="p-3">
                                <div class="form-group m-0">
                                    <div class="input-group">
                                        <input id="searchFilter" type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                                        <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
    
                    @if(!isPlatformModeInview || platformInviewService.getMode()==='suresim') {
    
                        @if(topBarShowAnimations || showTemplateMenuItems){
                        <div class="header-item" ngbDropdown>
                            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" (click)="imageIconClick()">
                                <img src="assets/images/_images/Image-Icon-200x158.png" alt="Header Image" height="20" class="rounded">
                            </button>
                        </div>
                        }
        
                        @if(showMobileMigrationIcon){
                            <div class="ms-1 header-item d-none d-sm-flex">
                                <button
                                  class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                  [disabled]="mobileMigrationRunning"
                                  [ngbTooltip]="showTooltips ? 'Run mobile number migration' : null"
                                  placement="bottom"
                                  tooltipClass="custom-tooltip-success"
                                  type="button"
                                  (click)="runMobileMigrationClick()"
                                >
                                    @if(mobileMigrationRunning){
                                        <span class="spinner-border spinner-border-sm" role="status"></span>
                                    } @else {
                                        <i class='mdi mdi-cellphone-arrow-down fs-22'></i>
                                    }
                                </button>
                            </div>
                        }

                        @if(testMode){
                            <div class="ms-1 header-item d-none d-sm-flex">
                                <button
                                  class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                  [ngbTooltip]="showTooltips ? 'Test' : null"
                                  placement="bottom"
                                  tooltipClass="custom-tooltip-success"
                                  type="button"
                                  (click)="testIconClick()"
                                >
                                    <i class='mdi mdi-flask-outline fs-22'></i>
                                </button>
                            </div>
                        }

                        @if((topBarShowSsoLoginIcon || curUser.systemAdmin) && ssoLoggedIn){
                            <div class="ms-1 header-item d-none d-sm-flex">
                                <button
                                  #tooltipSsoLogin="ngbTooltip"
                                  class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                  [ngbTooltip]="showTooltips ? 'SSO Login' : null"
                                  placement="bottom"
                                  tooltipClass="custom-tooltip-success"
                                  type="button"
                                  (click)="ssoLoginIconClick()"
                                  (mouseenter)="ssoLoginIconMouseEnter()"
                                >
                                    <i class='bi bi-person-lock fs-22'></i>
                                </button>
                            </div>
                        }

                        @if((topBarShowUploads || showTemplateMenuItems) && (curUser.systemAdmin || curUser.systemAdminStd)){
                            <div class="ms-1 header-item d-none d-sm-flex">
                                <button
                                  #tooltipUploads="ngbTooltip"
                                  class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                  data-toggle="fullscreen"
                                  [ngbTooltip]="showTooltips ? 'Upload Centre' : null"
                                  placement="bottom"
                                  tooltipClass="custom-tooltip-success"
                                  type="button"
                                  (click)="uploadCentreIconClick()"
                                  (mouseenter)="uploadCentreIconMouseEnter()"
                                >
                                    <i class='bx bx-upload fs-22'></i>
                                </button>
                            </div>
                        }
        
                        @if(topBarShowDownloads || showTemplateMenuItems){
                            <div class="ms-1 header-item d-none d-sm-flex">
                                <button
                                  #tooltipDownloads="ngbTooltip"
                                  class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                  data-toggle="fullscreen"
                                  [ngbTooltip]="showTooltips ? 'Download Centre' : null"
                                  placement="bottom"
                                  tooltipClass="custom-tooltip-success"
                                  type="button"
                                  (click)="downloadCentreIconClick()"
                                  (mouseenter)="downloadCentreIconMouseEnter()"
                                >
                                    <i class='bx bx-download fs-22'></i>
                                </button>
                            </div>
                        }
                        
                        @if((curUser.systemAdmin || showTemplateMenuItems || topBarShowTimeline)){
                            <div class="ms-1 header-item d-none d-sm-flex">
                                <button
                                  #tooltipTimeline="ngbTooltip"
                                  class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                  data-toggle="fullscreen"
                                  [ngbTooltip]="showTooltips ? 'Live View' : null"
                                  placement="bottom"
                                  tooltipClass="custom-tooltip-success"
                                  type="button"
                                  (click)="timelineIconClick()"
                                  (mouseenter)="timelineIconMouseEnter()"
                                >
                                    <i class='mdi mdi-clock-outline fs-22'></i>
                                </button>
                            </div>
                        }
                        
                        @if (showAssistant) {
                            <div class="ms-1 header-item d-none d-sm-flex">
                                <button
                                  #tooltipChatGpt="ngbTooltip"
                                  class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                                  data-toggle="fullscreen"
                                  [ngbTooltip]="showTooltips ? chatGptAliasFull : null"
                                  placement="bottom"
                                  tooltipClass="custom-tooltip-success"
                                  type="button"
                                  (click)="chatGptIconClick()"
                                  (mouseenter)="chatGptIconMouseEnter()"
                                >
                                    <img src="assets/images/_images/OpenAI.png" alt="Header Image" height="20" class="rounded">
                                </button>
                            </div>
                        }
        
                        @if(topBarShowLanguage || showTemplateMenuItems){    
                        <div class="dropdown ms-1 topbar-head-dropdown header-item" ngbDropdown>
                            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                @if(flagvalue === undefined){
                                <img src="{{valueset}}" alt="Header Language" height="20" class="rounded">
                                }@else {
                                <img src="{{flagvalue}}" alt="Header Language" height="20" class="rounded">
                                }
                            </button>
                            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
        
                                <!-- item-->
                                @for(item of listLang;track $index){
                                <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" data-lang="eng" (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
                                    <img src="{{item.flag}}" alt="user-image" class="me-2 rounded" height="18"> <span class="align-middle">{{item.text}}</span>
                                </a>
                                }
                            </div>
                        </div>
                        }
        
                        @if(topBarShowApps || showTemplateMenuItems) {
                        <div class="dropdown topbar-head-dropdown ms-1 header-item" ngbDropdown>
                            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                <i class='bx bx-category-alt fs-22'></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end" ngbDropdownMenu>
                                <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <h6 class="m-0 fw-semibold fs-15"> Web Apps </h6>
                                        </div>
                                        <div class="col-auto">
                                            <a href="javascript:void(0);" class="btn btn-sm btn-soft-info"> View All Apps
                                                <i class="ri-arrow-right-s-line align-middle"></i></a>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="p-2">
                                    <div class="row g-0">
                                        <div class="col">
                                            <a class="dropdown-icon-item" href="javascript:void(0);">
                                                <img src="assets/images/brands/github.png" alt="Github">
                                                <span>GitHub</span>
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a class="dropdown-icon-item" href="javascript:void(0);">
                                                <img src="assets/images/brands/bitbucket.png" alt="bitbucket">
                                                <span>Bitbucket</span>
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a class="dropdown-icon-item" href="javascript:void(0);">
                                                <img src="assets/images/brands/dribbble.png" alt="dribbble">
                                                <span>Dribbble</span>
                                            </a>
                                        </div>
                                    </div>
        
                                    <div class="row g-0">
                                        <div class="col">
                                            <a class="dropdown-icon-item" href="javascript:void(0);">
                                                <img src="assets/images/brands/dropbox.png" alt="dropbox">
                                                <span>Dropbox</span>
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a class="dropdown-icon-item" href="javascript:void(0);">
                                                <img src="assets/images/brands/mail_chimp.png" alt="mail_chimp">
                                                <span>Mail Chimp</span>
                                            </a>
                                        </div>
                                        <div class="col">
                                            <a class="dropdown-icon-item" href="javascript:void(0);">
                                                <img src="assets/images/brands/slack.png" alt="slack">
                                                <span>Slack</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
        
                        @if(topBarShowCart || showTemplateMenuItems) {
                        <div class="dropdown topbar-head-dropdown ms-1 header-item" ngbDropdown>
                            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" id="page-header-cart-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                                <i class='bx bx-shopping-bag fs-22'></i>
                                <span class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-info">{{cart_length}}<span class="visually-hidden">unread messages</span></span>
                            </button>
                            <div class="dropdown-menu dropdown-menu-xl dropdown-menu-end p-0" aria-labelledby="page-header-cart-dropdown" ngbDropdownMenu>
                                <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <h6 class="m-0 fs-16 fw-semibold"> My Cart</h6>
                                        </div>
                                        <div class="col-auto">
                                            <span class="badge bg-info-subtle text-info fs-13"> {{cart_length}} items</span>
                                        </div>
                                    </div>
                                </div>
                                <ngx-simplebar style="max-height: 300px;">
                                    <div class="p-2">
                                        <div class="text-center empty-cart" id="empty-cart" style="display: none;">
                                            <div class="avatar-md mx-auto my-3">
                                                <div class="avatar-title bg-info-subtle text-info fs-36 rounded-circle">
                                                    <i class='bx bx-cart'></i>
                                                </div>
                                            </div>
                                            <h5 class="mb-3">Your Cart is Empty!</h5>
                                            <a routerLink="/ecommerce/products" class="btn btn-success w-md mb-3">Shop Now</a>
                                        </div>
                                        @for(data of cartData;track $index){
                                        <div class="d-block dropdown-item text-wrap px-3 py-2" id="item_{{data.id}}">
                                            <div class="d-flex align-items-center">
                                                <img src="{{data.img}}" class="me-3 rounded-circle avatar-sm p-2 bg-light" alt="user-pic">
                                                <div class="flex-grow-1">
                                                    <h6 class="mt-0 mb-1 fs-14">
                                                        <a routerLink="/ecommerce/product-detail" class="text-reset">{{data.product}}</a>
                                                    </h6>
                                                    <p class="mb-0 fs-12 text-muted">
                                                        Quantity: <span>{{data.quantity}} x ${{data.price}}</span>
                                                    </p>
                                                </div>
                                                <div class="px-2">
                                                    <h5 class="m-0 fw-normal">$ <span class="item_price">{{data.quantity *
                                                            data.price}}</span></h5>
                                                </div>
                                                <div class="ps-2">
                                                    <button type="button" class="btn btn-icon btn-sm btn-ghost-secondary" (click)="deleteItem($event,data.id)">
                                                        <i class="ri-close-fill fs-16"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </ngx-simplebar>
                                <div class="p-3 border-bottom-0 border-start-0 border-end-0 border-dashed border d-grid">
                                    <div class="d-flex justify-content-between align-items-center pb-3">
                                        <h5 class="m-0 text-muted">Total:</h5>
                                        <div class="px-2">
                                            <h5 class="m-0">$<span class="total_price">{{total}}</span></h5>
                                        </div>
                                    </div>
        
                                    <a routerLink="/ecommerce/checkout" class="btn btn-success text-center">
                                        Checkout
                                    </a>
                                </div>
                            </div>
                        </div>
                        }
        
                        @if(showSupportPage) {
                        <div class="ms-1 header-item d-none d-sm-flex">
                            <button
                              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                              [ngbTooltip]="showTooltips ? 'Support' : null"
                              placement="bottom"
                              tooltipClass="custom-tooltip-success"
                              type="button"
                              routerLink="/support/support-page"
                            >
                                <i class='bx bx-help-circle fs-22'></i>
                            </button>
                        </div>
                        }

                        @if(topBarShowFullScreen || showTemplateMenuItems) {
                        <div class="ms-1 header-item d-none d-sm-flex">
                            <button
                              #tooltipFullscreen="ngbTooltip"
                              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                              data-toggle="fullscreen"
                              [ngbTooltip]="showTooltips ? (isFullscreen ? 'Exit Fullscreen' : 'Fullscreen') : null"
                              placement="bottom"
                              tooltipClass="custom-tooltip-success"
                              type="button"
                              (click)="fullscreen()"
                              (mouseenter)="fullscreenIconMouseEnter()"
                            >
                                <i class='bx bx-fullscreen fs-22'></i>
                            </button>
                        </div>
                        }
        
                        @if(topBarShowDarkMode || showTemplateMenuItems) {
                        <div class="ms-1 header-item d-none d-sm-flex">
                            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode">
                                <i class='bx bx-moon fs-22' (click)="changeMode('dark')"></i>
                                <i class='bx bx-sun fs-22' (click)="changeMode('light')"></i>
                            </button>
                        </div>
                        }
        
                        @if(topBarShowNotifications || showTemplateMenuItems) {
                          <app-page-comp-menu-notifications
                           (openCommunicationModal)="openCommunication($event)"
                           (viewNotifications)="viewNotifications()"
                          >
                          </app-page-comp-menu-notifications>
                        }
    
                    }
    
                    @if(showTemplateMenuItems) {
                    <div ngbDropdown [autoClose]="false" class="dropdown topbar-head-dropdown ms-1 header-item">
                        <button type="button" ngbDropdownToggle class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class='bx bx-bell fs-22'></i>
                            <span class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">3<span class="visually-hidden">unread messages</span></span>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown">
    
                            <div class="dropdown-head bg-secondary bg-pattern rounded-top">
                                <div class="p-3">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <h6 class="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                                        </div>
                                        <div class="col-auto dropdown-tabs">
                                            <span class="badge bg-light-subtle text-body fs-13"> {{allnotifications?.length}} New</span>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="px-2 pt-2">
                                    <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav nav-tabs dropdown-tabs nav-tabs-custom" id="notificationItemsTab">
                                        <li [ngbNavItem]="1">
                                            <a ngbNavLink>
                                                All ({{allnotifications?.length}})
                                            </a>
                                            <ng-template ngbNavContent>
                                                <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel">
                                                    <ngx-simplebar style="max-height: 300px;">
                                                        <div class="pe-2">
                                                            @for(item of allnotifications;track $index){
                                                            <div class="text-reset notification-item d-block dropdown-item position-relative">
                                                                <div class=" d-flex">
                                                                    @if(item.img){
                                                                    <img src="{{item.img}}" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                                                    <div class="flex-grow-1">
                                                                        <a href="javascript:void(0);" class="stretched-link">
                                                                            <h6 class="mt-0 mb-1 fs-13 fw-semibold">{{item.title}}</h6>
                                                                        </a>
                                                                        <div class="fs-13 text-muted">
                                                                            <p class="mb-1">{{item.desc}}</p>
                                                                        </div>
                                                                        <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                                            <span><i class="mdi mdi-clock-outline"></i> {{item.time}}</span>
                                                                        </p>
                                                                    </div>
                                                                    }@else {
                                                                    <div class="avatar-xs me-3">
                                                                        <span class="avatar-title bg-info-subtle text-info rounded-circle fs-16">
                                                                            <i class="bx {{item.icon}}"></i>
                                                                        </span>
                                                                    </div>
                                                                    <div class="flex-grow-1">
                                                                        <a href="javascript:void(0);" class="stretched-link">
                                                                            <h6 class="mt-0 mb-2 lh-base">{{item.desc}}
                                                                            </h6>
                                                                        </a>
                                                                        <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                                            <span><i class="mdi mdi-clock-outline"></i>{{item.time}}</span>
                                                                        </p>
                                                                    </div>
                                                                    }
    
    
                                                                    <div class="px-2 fs-15">
                                                                        <input id="{{item.checkboxId}}" class="form-check-input" type="checkbox" [(ngModel)]="item.state" (change)="onCheckboxChange($event,'1')" value="{{item.id}}">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            } @empty{
                                                            <div class="tab-pane p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">
                                                                <div class="w-25 w-sm-50 pt-3 mx-auto">
                                                                    <img src="assets/images/svg/bell.svg" class="img-fluid" alt="user-pic">
                                                                </div>
                                                                <div class="text-center pb-5 mt-2">
                                                                    <h6 class="fs-18 fw-semibold lh-base">Hey! You have no any
                                                                        notifications </h6>
                                                                </div>
                                                            </div>
                                                            }
                                                            @if(allnotifications?.length > 0){
                                                            <div class="my-3 text-center">
                                                                <button type="button" class="btn btn-soft-success waves-effect waves-light">View
                                                                    All Notifications <i class="ri-arrow-right-line align-middle"></i></button>
                                                            </div>
                                                            }
                                                        </div>
    
    
                                                    </ngx-simplebar>
                                                </div>
                                            </ng-template>
                                        </li>
                                        <li [ngbNavItem]="2">
                                            <a ngbNavLink>
                                                Messages
                                            </a>
                                            <ng-template ngbNavContent>
                                                <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel">
                                                    <ngx-simplebar style="max-height: 300px;">
                                                        <div class="pe-2">
                                                            @for(message of messages;track $index){
                                                            <div class="text-reset notification-item d-block dropdown-item">
                                                                <div class="d-flex">
                                                                    <img src="{{message.avatar}}" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                                                    <div class="flex-grow-1">
                                                                        <a href="javascript:void(0);" class="stretched-link">
                                                                            <h6 class="mt-0 mb-1 fs-13 fw-semibold">{{message.name}}</h6>
                                                                        </a>
                                                                        <div class="fs-13 text-muted">
                                                                            <p class="mb-1">{{message.message}}</p>
                                                                        </div>
                                                                        <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                                            <span><i class="mdi mdi-clock-outline"></i> {{message.time_ago}}</span>
                                                                        </p>
                                                                    </div>
                                                                    <div class="px-2 fs-15">
                                                                        <input class="form-check-input" type="checkbox" value="{{message.id}}" [(ngModel)]="message.state" (change)="onCheckboxChange($event,'2')" id="{{message.checkboxId}}">
                                                                        <label class="form-check-label" for="{{message.checkboxId}}"></label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            }@empty {
                                                            <div class="tab-pane p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">
                                                                <div class="w-25 w-sm-50 pt-3 mx-auto">
                                                                    <img src="assets/images/svg/bell.svg" class="img-fluid" alt="user-pic">
                                                                </div>
                                                                <div class="text-center pb-5 mt-2">
                                                                    <h6 class="fs-18 fw-semibold lh-base">Hey! You have no any
                                                                        notifications </h6>
                                                                </div>
                                                            </div>
                                                            }
                                                            @if(messages?.length > 0){
                                                            <div class="my-3 text-center">
                                                                <button type="button" class="btn btn-soft-success waves-effect waves-light">View
                                                                    All Messages <i class="ri-arrow-right-line align-middle"></i></button>
                                                            </div>
                                                            }
                                                        </div>
    
    
                                                    </ngx-simplebar>
                                                </div>
                                            </ng-template>
                                        </li>
                                        <li [ngbNavItem]="3">
                                            <a ngbNavLink>
                                                Alerts
                                            </a>
                                            <ng-template ngbNavContent>
                                                <div class="tab-pane p-4" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab">
                                                    <div class="w-25 w-sm-50 pt-3 mx-auto">
                                                        <img src="assets/images/svg/bell.svg" class="img-fluid" alt="user-pic">
                                                    </div>
                                                    <div class="text-center pb-5 mt-2">
                                                        <h6 class="fs-18 fw-semibold lh-base">Hey! You have no any
                                                            notifications </h6>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </li>
    
                                    </ul>
                                </div>
    
                            </div>
    
                            <div class="tab-content" id="notificationItemsTabContent">
                                <div class="tab-content text-muted">
                                    <div [ngbNavOutlet]="nav"></div>
                                </div>
                            </div>
    
                            <div class="notification-actions" id="notification-actions">
                                <div class=" d-flex text-muted justify-content-center">
                                    Select <div id="select-content" class="text-body fw-semibold px-1">{{checkedValGet.length}}</div> Result <button type="button" class="btn btn-link link-danger p-0 ms-3" data-bs-toggle="modal" (click)="openModal(removenotification)" data-bs-target="#removeNotificationModal">Remove</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
    
                    @if (topBarShowClock && clockBarDismissed) {
                        <!--CRN_20260512 - Compact clock icon shown when clock bar is hidden-->
                        <div class="ms-1 header-item">
                            <app-clock-chip-group
                              [dropdownContainer]="null"
                              [editable]="true"
                              [hideFlags]="topBarWorldClockHideFlags">
                            </app-clock-chip-group>
                        </div>
                    }

                    <div class="dropdown ms-sm-3 header-item topbar-user" ngbDropdown>
                        <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                            <span class="d-flex align-items-center justify-content-center">
                                <i class="mdi mdi-account-circle header-profile-user" [class.header-profile-user-suresim]="!isPlatformModeInview" aria-label="Header Avatar"></i>
                            </span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                            <h6 class="dropdown-header">{{designation()}}</h6>
                            <div class="dropdown-divider"></div>
                             @if(topBarShowMenuItems || showTemplateMenuItems) {
                            <a class="dropdown-item" routerLink="/pages/profile"><i class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Profile</span></a>
                            <a class="dropdown-item" routerLink="/apps/chat"><i class="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Messages</span></a>
                            <a class="dropdown-item" routerLink="/tasks/kanban"><i class="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Taskboard</span></a>
                            <a class="dropdown-item" routerLink="/pages/faqs"><i class="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Help</span></a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" routerLink="/pages/profile"><i class="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Balance : <b>$5971.67</b></span></a>
                            <a class="dropdown-item" routerLink="/pages/profile"><span class="badge bg-success-subtle text-success mt-1 float-end">New</span><i class="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Settings</span></a>
                            }
                            @if (!ssoLoggedIn) {
                              <a class="dropdown-item" (click)="lockScreen()"><i class="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Lock screen</span></a>
                            }
                            <a class="dropdown-item" href="javascript: void(0);" (click)="startLogOut(false)"><i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span class="align-middle" data-key="t-logout">{{logoutText}}</span></a>
                            @if (ssoLoggedIn) {
                              <a class="dropdown-item" href="javascript: void(0);" (click)="startLogOut(true)"><i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span class="align-middle" data-key="t-logout">Logout of {{ourCompanyName}} & Microsoft</span></a>
                            }
                        </div>
                    </div>
                }

                <button
                  #topbarToggleBtn
                  #tooltipToggleBtn="ngbTooltip"
                  class="btn btn-icon btn-topbar btn-ghost-secondary topbar-icons-toggle ms-1"
                  [ngbTooltip]="showTooltips ? (topbarIconsCollapsed ? 'Show toolbar' : 'Hide toolbar') : null"
                  placement="bottom-right"
                  tooltipClass="custom-tooltip-success"
                  type="button"
                  (click)="toggleTopbarIcons()"
                >
                    <i class="mdi {{ topbarIconsCollapsed ? 'mdi-triangle-down' : 'mdi-triangle' }}"></i>
                </button>

            </div>
        </div>
    </div>
    <div class="row" *ngIf="progressInformationShow" #progressInfoRow>
      <div class="col-12">
        <div class="mb-0 px-2">
          <label class="form-label text-right"></label>
          <div class="alert border-0 {{alertColourProgress}} alert-dismissible d-flex align-items-center" role="alert">
            <div class="d-flex align-items-center flex-grow-1">
              <strong class="me-1">{{progressInformationType}}</strong>
              <span class="me-1">-</span>
              <span [innerHtml]="progressInformation"></span>
            </div>
            <button type="button" class="btn-close ms-3" aria-label="Close" (click)="dismissProgressInformation()"></button>
          </div>
        </div>
      </div>
    </div>
</header>

<!-- removeNotificationModal -->
<ng-template #removenotification let-modal>
    <!-- <div class="modal-dialog modal-dialog-centered"> -->
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="NotificationModalbtn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="mt-2 text-center">
                <!-- <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon> -->
                <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4>Are you sure ?</h4>
                    <p class="text-muted mx-4 mb-0">Are you sure you want to remove this Notification ?</p>
                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.dismiss('Cross click')">Close</button>
                <button type="button" class="btn w-sm btn-danger" id="delete-notification" (click)="notificationDelete()">Yes, Delete It!</button>
            </div>
        </div>

    </div><!-- /.modal-content -->

</ng-template>

<app-chat-gpt-modal-form #chatGptModalForm
  (assistantActionRequested)="onAssistantActionRequested($event)"
></app-chat-gpt-modal-form>

<app-download-centre-modal-form #downloadCentreForm
></app-download-centre-modal-form>

<app-communication-grid-modal-form #communicationGridModalForm
></app-communication-grid-modal-form>

<app-company-modal-form #companyModalForm
  (companyFormCancelled)="companyFormHasBeenCancelled()"
  (sureSimCompanyDataHasBeenSaved)="companyDataHasBeenSaved($event)"
></app-company-modal-form>

<app-images-modal-form #imageModalForm
></app-images-modal-form>

<app-information-modal-form #informationModalForm
></app-information-modal-form>

<app-provision-modal-form #provisionModalForm
  (iccidHasBeenProvisioned)="iccidHasBeenProvisioned()"
  (provisionESIMFormHasBeenCancelled)="provisionESIMFormHasBeenCancelled()"
></app-provision-modal-form>

<app-ticket-modal-form #ticketModalForm
  [initialSureSimCompanyId]="sureSimCompanyId"
  (ticketFormCancelled)="ticketFormHasBeenCancelled()"
  (ticketFormHasBeenSaved)="ticketFormHasBeenSaved()"
></app-ticket-modal-form>

<app-add-ticket-note-modal-form #ticketNotesModalForm
  (ticketNoteFormCancelled)="ticketNoteFormHasBeenCancelled()"
  (ticketNoteFormHasBeenSaved)="ticketNoteFormHasBeenSaved()"
></app-add-ticket-note-modal-form>

<app-timeline-esim-modal-form #timelineModalForm
></app-timeline-esim-modal-form>

<app-manage-esim-modal-form #manageEsimModalForm
></app-manage-esim-modal-form>

<app-upload-centre-modal-form #uploadCentreForm
></app-upload-centre-modal-form>

<app-user-modal-form #userModalForm
  [initialInviewCompanyId]="aiInitialInviewCompanyId ?? inviewCompanyId"
  (sureSimUserDataHasBeenSaved)="userDataHasBeenSaved($event)"
  (userFormCancelled)="userFormHasBeenCancelled()"
></app-user-modal-form>
